var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthorisedUserIconFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_150_135",
    "data-name": "Component 150 \\u2013 135",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    fill: "#ff3535",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_119",
    "data-name": "Union 119",
    d: "M6805.162-12225.918v-1.42a2.132,2.132,0,0,0-2.129-2.129h-4.967a2.11,2.11,0,0,0-1.505.622,2.113,2.113,0,0,0-.624,1.507v1.42a.71.71,0,0,1-.71.709.71.71,0,0,1-.709-.709v-1.42a3.523,3.523,0,0,1,1.039-2.509,3.526,3.526,0,0,1,2.51-1.04h4.967a3.553,3.553,0,0,1,3.549,3.549v1.42a.71.71,0,0,1-.71.709A.709.709,0,0,1,6805.162-12225.918Zm2.337-5.177-1.419-1.42a.708.708,0,0,1,0-1,.708.708,0,0,1,1,0l.918.917,2.337-2.336a.709.709,0,0,1,1,0,.709.709,0,0,1,0,1l-2.838,2.84a.71.71,0,0,1-.5.208A.706.706,0,0,1,6807.5-12231.095Zm-10.5-4.761a3.552,3.552,0,0,1,3.548-3.549,3.552,3.552,0,0,1,3.548,3.549,3.552,3.552,0,0,1-3.548,3.549A3.552,3.552,0,0,1,6797-12235.855Zm1.419,0a2.132,2.132,0,0,0,2.129,2.129,2.132,2.132,0,0,0,2.129-2.129,2.132,2.132,0,0,0-2.129-2.129A2.132,2.132,0,0,0,6798.42-12235.855Z",
    transform: "translate(-6784.516 12249.404)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorisedUserIconFilled);
export default __webpack_public_path__ + "static/media/authorisedUser-icon-filled.b59ef6f55753b8ea067077345a6d3c9f.svg";
export { ForwardRef as ReactComponent };